/* eslint-disable */

export const protobufPackage = "od_protos.journey.data.categories";

export interface AgentConnectCategory {
  event?:
    | { $case: "viewEvent"; viewEvent: AgentConnectCategory_ViewEvent }
    | { $case: "handoffEvent"; handoffEvent: AgentConnectCategory_HandoffEvent }
    | { $case: "deniedEvent"; deniedEvent: AgentConnectCategory_DeniedEvent }
    | undefined;
}

export enum AgentConnectCategory_Partner {
  UNKNOWN_PARTNER = 0,
  MSRE = 1,
  REDFIN = 2,
  JMG = 3,
  CLEVER = 4,
  PARN = 5,
  UNRECOGNIZED = -1,
}

export function agentConnectCategory_PartnerFromJSON(object: any): AgentConnectCategory_Partner {
  switch (object) {
    case 0:
    case "UNKNOWN_PARTNER":
      return AgentConnectCategory_Partner.UNKNOWN_PARTNER;
    case 1:
    case "MSRE":
      return AgentConnectCategory_Partner.MSRE;
    case 2:
    case "REDFIN":
      return AgentConnectCategory_Partner.REDFIN;
    case 3:
    case "JMG":
      return AgentConnectCategory_Partner.JMG;
    case 4:
    case "CLEVER":
      return AgentConnectCategory_Partner.CLEVER;
    case 5:
    case "PARN":
      return AgentConnectCategory_Partner.PARN;
    case -1:
    case "UNRECOGNIZED":
    default:
      return AgentConnectCategory_Partner.UNRECOGNIZED;
  }
}

export function agentConnectCategory_PartnerToJSON(object: AgentConnectCategory_Partner): string {
  switch (object) {
    case AgentConnectCategory_Partner.UNKNOWN_PARTNER:
      return "UNKNOWN_PARTNER";
    case AgentConnectCategory_Partner.MSRE:
      return "MSRE";
    case AgentConnectCategory_Partner.REDFIN:
      return "REDFIN";
    case AgentConnectCategory_Partner.JMG:
      return "JMG";
    case AgentConnectCategory_Partner.CLEVER:
      return "CLEVER";
    case AgentConnectCategory_Partner.PARN:
      return "PARN";
    case AgentConnectCategory_Partner.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum AgentConnectCategory_SellerIntent {
  UNKNOWN = 0,
  LIST = 1,
  CASH = 2,
  CASH_PLUS = 3,
  UNRECOGNIZED = -1,
}

export function agentConnectCategory_SellerIntentFromJSON(object: any): AgentConnectCategory_SellerIntent {
  switch (object) {
    case 0:
    case "UNKNOWN":
      return AgentConnectCategory_SellerIntent.UNKNOWN;
    case 1:
    case "LIST":
      return AgentConnectCategory_SellerIntent.LIST;
    case 2:
    case "CASH":
      return AgentConnectCategory_SellerIntent.CASH;
    case 3:
    case "CASH_PLUS":
      return AgentConnectCategory_SellerIntent.CASH_PLUS;
    case -1:
    case "UNRECOGNIZED":
    default:
      return AgentConnectCategory_SellerIntent.UNRECOGNIZED;
  }
}

export function agentConnectCategory_SellerIntentToJSON(object: AgentConnectCategory_SellerIntent): string {
  switch (object) {
    case AgentConnectCategory_SellerIntent.UNKNOWN:
      return "UNKNOWN";
    case AgentConnectCategory_SellerIntent.LIST:
      return "LIST";
    case AgentConnectCategory_SellerIntent.CASH:
      return "CASH";
    case AgentConnectCategory_SellerIntent.CASH_PLUS:
      return "CASH_PLUS";
    case AgentConnectCategory_SellerIntent.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Triggered whenever a Partner page is shown to refer in Agent Connect */
export interface AgentConnectCategory_ViewEvent {
  sellerInputUuid: string;
  partner: AgentConnectCategory_Partner;
  odEstimatedSalePriceCents?: number | undefined;
  buyerIntent: boolean;
}

/** Triggered whenever a customer completes a handoff to a referral partner */
export interface AgentConnectCategory_HandoffEvent {
  sellerInputUuid: string;
  partner: AgentConnectCategory_Partner;
  sellerIntent: AgentConnectCategory_SellerIntent;
  buyerIntent: boolean;
  odEstimatedSalePriceCents?: number | undefined;
}

/** Triggered whenever a customer is shown a denial page other than a partner referral */
export interface AgentConnectCategory_DeniedEvent {
  sellerInputUuid: string;
  denialReason: string;
}

function createBaseAgentConnectCategory(): AgentConnectCategory {
  return { event: undefined };
}

export const AgentConnectCategory = {
  fromJSON(object: any): AgentConnectCategory {
    return {
      event: isSet(object.viewEvent)
        ? { $case: "viewEvent", viewEvent: AgentConnectCategory_ViewEvent.fromJSON(object.viewEvent) }
        : isSet(object.handoffEvent)
        ? { $case: "handoffEvent", handoffEvent: AgentConnectCategory_HandoffEvent.fromJSON(object.handoffEvent) }
        : isSet(object.deniedEvent)
        ? { $case: "deniedEvent", deniedEvent: AgentConnectCategory_DeniedEvent.fromJSON(object.deniedEvent) }
        : undefined,
    };
  },

  toJSON(message: AgentConnectCategory): unknown {
    const obj: any = {};
    if (message.event?.$case === "viewEvent") {
      obj.viewEvent = AgentConnectCategory_ViewEvent.toJSON(message.event.viewEvent);
    }
    if (message.event?.$case === "handoffEvent") {
      obj.handoffEvent = AgentConnectCategory_HandoffEvent.toJSON(message.event.handoffEvent);
    }
    if (message.event?.$case === "deniedEvent") {
      obj.deniedEvent = AgentConnectCategory_DeniedEvent.toJSON(message.event.deniedEvent);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AgentConnectCategory>, I>>(base?: I): AgentConnectCategory {
    return AgentConnectCategory.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AgentConnectCategory>, I>>(object: I): AgentConnectCategory {
    const message = createBaseAgentConnectCategory();
    if (
      object.event?.$case === "viewEvent" && object.event?.viewEvent !== undefined && object.event?.viewEvent !== null
    ) {
      message.event = {
        $case: "viewEvent",
        viewEvent: AgentConnectCategory_ViewEvent.fromPartial(object.event.viewEvent),
      };
    }
    if (
      object.event?.$case === "handoffEvent" &&
      object.event?.handoffEvent !== undefined &&
      object.event?.handoffEvent !== null
    ) {
      message.event = {
        $case: "handoffEvent",
        handoffEvent: AgentConnectCategory_HandoffEvent.fromPartial(object.event.handoffEvent),
      };
    }
    if (
      object.event?.$case === "deniedEvent" &&
      object.event?.deniedEvent !== undefined &&
      object.event?.deniedEvent !== null
    ) {
      message.event = {
        $case: "deniedEvent",
        deniedEvent: AgentConnectCategory_DeniedEvent.fromPartial(object.event.deniedEvent),
      };
    }
    return message;
  },
};

function createBaseAgentConnectCategory_ViewEvent(): AgentConnectCategory_ViewEvent {
  return { sellerInputUuid: "", partner: 0, odEstimatedSalePriceCents: undefined, buyerIntent: false };
}

export const AgentConnectCategory_ViewEvent = {
  fromJSON(object: any): AgentConnectCategory_ViewEvent {
    return {
      sellerInputUuid: isSet(object.sellerInputUuid) ? String(object.sellerInputUuid) : "",
      partner: isSet(object.partner) ? agentConnectCategory_PartnerFromJSON(object.partner) : 0,
      odEstimatedSalePriceCents: isSet(object.odEstimatedSalePriceCents)
        ? Number(object.odEstimatedSalePriceCents)
        : undefined,
      buyerIntent: isSet(object.buyerIntent) ? Boolean(object.buyerIntent) : false,
    };
  },

  toJSON(message: AgentConnectCategory_ViewEvent): unknown {
    const obj: any = {};
    if (message.sellerInputUuid !== "") {
      obj.sellerInputUuid = message.sellerInputUuid;
    }
    if (message.partner !== 0) {
      obj.partner = agentConnectCategory_PartnerToJSON(message.partner);
    }
    if (message.odEstimatedSalePriceCents !== undefined) {
      obj.odEstimatedSalePriceCents = message.odEstimatedSalePriceCents;
    }
    if (message.buyerIntent === true) {
      obj.buyerIntent = message.buyerIntent;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AgentConnectCategory_ViewEvent>, I>>(base?: I): AgentConnectCategory_ViewEvent {
    return AgentConnectCategory_ViewEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AgentConnectCategory_ViewEvent>, I>>(
    object: I,
  ): AgentConnectCategory_ViewEvent {
    const message = createBaseAgentConnectCategory_ViewEvent();
    message.sellerInputUuid = object.sellerInputUuid ?? "";
    message.partner = object.partner ?? 0;
    message.odEstimatedSalePriceCents = object.odEstimatedSalePriceCents ?? undefined;
    message.buyerIntent = object.buyerIntent ?? false;
    return message;
  },
};

function createBaseAgentConnectCategory_HandoffEvent(): AgentConnectCategory_HandoffEvent {
  return { sellerInputUuid: "", partner: 0, sellerIntent: 0, buyerIntent: false, odEstimatedSalePriceCents: undefined };
}

export const AgentConnectCategory_HandoffEvent = {
  fromJSON(object: any): AgentConnectCategory_HandoffEvent {
    return {
      sellerInputUuid: isSet(object.sellerInputUuid) ? String(object.sellerInputUuid) : "",
      partner: isSet(object.partner) ? agentConnectCategory_PartnerFromJSON(object.partner) : 0,
      sellerIntent: isSet(object.sellerIntent) ? agentConnectCategory_SellerIntentFromJSON(object.sellerIntent) : 0,
      buyerIntent: isSet(object.buyerIntent) ? Boolean(object.buyerIntent) : false,
      odEstimatedSalePriceCents: isSet(object.odEstimatedSalePriceCents)
        ? Number(object.odEstimatedSalePriceCents)
        : undefined,
    };
  },

  toJSON(message: AgentConnectCategory_HandoffEvent): unknown {
    const obj: any = {};
    if (message.sellerInputUuid !== "") {
      obj.sellerInputUuid = message.sellerInputUuid;
    }
    if (message.partner !== 0) {
      obj.partner = agentConnectCategory_PartnerToJSON(message.partner);
    }
    if (message.sellerIntent !== 0) {
      obj.sellerIntent = agentConnectCategory_SellerIntentToJSON(message.sellerIntent);
    }
    if (message.buyerIntent === true) {
      obj.buyerIntent = message.buyerIntent;
    }
    if (message.odEstimatedSalePriceCents !== undefined) {
      obj.odEstimatedSalePriceCents = message.odEstimatedSalePriceCents;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AgentConnectCategory_HandoffEvent>, I>>(
    base?: I,
  ): AgentConnectCategory_HandoffEvent {
    return AgentConnectCategory_HandoffEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AgentConnectCategory_HandoffEvent>, I>>(
    object: I,
  ): AgentConnectCategory_HandoffEvent {
    const message = createBaseAgentConnectCategory_HandoffEvent();
    message.sellerInputUuid = object.sellerInputUuid ?? "";
    message.partner = object.partner ?? 0;
    message.sellerIntent = object.sellerIntent ?? 0;
    message.buyerIntent = object.buyerIntent ?? false;
    message.odEstimatedSalePriceCents = object.odEstimatedSalePriceCents ?? undefined;
    return message;
  },
};

function createBaseAgentConnectCategory_DeniedEvent(): AgentConnectCategory_DeniedEvent {
  return { sellerInputUuid: "", denialReason: "" };
}

export const AgentConnectCategory_DeniedEvent = {
  fromJSON(object: any): AgentConnectCategory_DeniedEvent {
    return {
      sellerInputUuid: isSet(object.sellerInputUuid) ? String(object.sellerInputUuid) : "",
      denialReason: isSet(object.denialReason) ? String(object.denialReason) : "",
    };
  },

  toJSON(message: AgentConnectCategory_DeniedEvent): unknown {
    const obj: any = {};
    if (message.sellerInputUuid !== "") {
      obj.sellerInputUuid = message.sellerInputUuid;
    }
    if (message.denialReason !== "") {
      obj.denialReason = message.denialReason;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AgentConnectCategory_DeniedEvent>, I>>(
    base?: I,
  ): AgentConnectCategory_DeniedEvent {
    return AgentConnectCategory_DeniedEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AgentConnectCategory_DeniedEvent>, I>>(
    object: I,
  ): AgentConnectCategory_DeniedEvent {
    const message = createBaseAgentConnectCategory_DeniedEvent();
    message.sellerInputUuid = object.sellerInputUuid ?? "";
    message.denialReason = object.denialReason ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Array<infer U> ? Array<DeepPartial<U>> : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string } ? { [K in keyof Omit<T, "$case">]?: DeepPartial<T[K]> } & { $case: T["$case"] }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
